<template>
    <div id="app" v-cloak>
        <main class="flex-grow">
            <div id="content">
                <nav role="navigation" id="navigation" class="fixed hidden md:block top-0 right-0 z-30 w-10 md:w-16 md:px-4">
                    <ul>
                        <li><a href="#intro" class="active">Intro</a></li>
                        <li><a href="#about">About</a></li>
                        <li><a href="#wallpaper">Wallpaper</a></li>
                        <li><a href="#event">Event</a></li>
                    </ul>
                </nav>
                <a @click="analytics.gaEvent('click', 'navigation', 'home_fnwc');" target="_blank" href="http://fnwc.org/">
                    <div class="logo-fnwc bottom-0 fixed p-4 right-0 z-30"><img :src="secure_asset('assets/images/logo-fnwc.png')" alt="logo of Families Network of Western Connecticut"><div id="pill" class="pill-fnwc rounded-full uppercase text-white">Visit Site</div></div>
                </a>
                <router-view/>
            </div>
        </main>
        <footer class="px-0 text-center">
            <div class="container mx-auto">
                <div class="flex flex-wrap">
                    <div class="w-full px-3">
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    import { mapActions, mapState} from 'vuex'

    export default {

        computed: {
            ...mapState('app', [
                'analytics',
                'nav',
                'privacy_policy',
                'promotion'
            ]),
        },

        methods: {
            ...mapActions('app', [
                'toggleMobileNav'
            ]),
        },
    }
      
</script>